<template>
  <footer
    v-if="!isStc"
    class="grow-0 text-[#222] text-[10px] flex justify-between px-2 py-1 font-light leading-normal"
  >
    <div>Powered by Scantrust</div>
    <div>v.{{ version }}</div>
  </footer>
</template>

<script setup>
defineProps({
  isStc: Boolean,
  version: String
})
</script>
